// Generated by CoffeeScript 2.7.0
import { unmountVueIn } from 'trunks/vue/share/mount.js';

var BaseBootloader;

export default BaseBootloader = {
  // Initializer
  init: function() {
    var action, body, controller;
    body = document.body;
    controller = body.data('controller');
    action = body.data('action');
    // disable scroll when modal is open
    body.addEventListener('touchmove', function(event) {
      if (body.hasClass('disable-scroll')) {
        return event.preventDefault();
      }
    });
    window.CurrentAttributes.init();
    window.$currentController = new (Skylark.App.Controllers.find(controller) || Skylark.App.BaseController)();
    if (_.isFunction($currentController.beforeAction)) {
      $currentController.beforeAction(action);
    }
    if (_.isFunction($currentController[action])) {
      $currentController[action]();
    }
    if (_.isFunction($currentController.afterAction)) {
      $currentController.afterAction(action);
    }
    return this.afterInitialize();
  },
  afterInitialize: _.noop,
  destruct: function() {
    window.CurrentAttributes.destruct();
    if (_.isFunction($currentController.beforeRender)) {
      return $currentController.beforeRender(document.body.data('action'));
    }
  },
  beforeVisit: function(event) {
    if (_.isFunction($currentController.beforeVisit)) {
      return $currentController.beforeVisit(event, document.body.data('action'));
    }
  },
  // unmount components generated by api
  unmountComponents: function() {
    var i, j, len, len1, node, nodes, ref, ref1, ref2, ref3, vue_node, vue_nodes;
    nodes = document.querySelectorAll('[data-generated-by-api]');
    for (i = 0, len = nodes.length; i < len; i++) {
      node = nodes[i];
      node.remove();
    }
    vue_nodes = document.querySelectorAll('[data-generated-by-vue]');
// remove vue components
    for (j = 0, len1 = vue_nodes.length; j < len1; j++) {
      vue_node = vue_nodes[j];
      if (vue_node.closest("[data-turbolinks-permanent]")) {
        continue;
      }
      if ((ref = vue_node.childNodes[0]) != null) {
        if ((ref1 = ref.__vue__) != null) {
          if (typeof ref1.beforeRemoved === "function") {
            ref1.beforeRemoved();
          }
        }
      }
      vue_node.remove();
      if ((ref2 = vue_node.childNodes[0]) != null) {
        if ((ref3 = ref2.__vue__) != null) {
          if (typeof ref3.afterRemoved === "function") {
            ref3.afterRemoved();
          }
        }
      }
    }
    unmountVueIn(document);
  },
  // Start
  start: function(afterInitializeCallback = _.noop) {
    if (Turbolinks.supported) {
      document.addEventListener('turbolinks:load', this.init.bind(this));
      document.addEventListener('turbolinks:before-visit', this.beforeVisit.bind(this));
      document.addEventListener('turbolinks:before-cache', this.unmountComponents.bind(this));
      return document.addEventListener('turbolinks:before-render', this.destruct.bind(this));
    } else {
      return document.addEventListener('DOMContentLoaded', this.init.bind(this));
    }
  }
};
